module.exports = __webpack_public_path__ + "static/sara-johnson-e39aae0bbc576f7061503a69c3ff8f76.jpg";